import { useSharedComponentsContext } from '../utils';

export const useGetExpertisesCategories = () => {
  const { t } = useSharedComponentsContext();
  return {
    advertising: t('base:expertises.categories.advertisingAndMarketing'),
    creative: t('base:expertises.categories.creativeAndVisual'),
    development: t('base:expertises.categories.developmentAndProduct'),
    'it-services': t('base:expertises.categories.itServices'),
  };
};

export type ExpertisesCategories = ReturnType<typeof useGetExpertisesCategories>;
